import React from "react";
import {
  Grid, TextField, Paper, Button, IconButton, Box
} from "@material-ui/core";
import { Add, Delete, Save } from "@material-ui/icons";
import TextFieldCPF from "../../components/TextFieldCPF";
import TextFieldEmail from "../../components/base/TextFieldEmail";
import Swal from "sweetalert2";




export default function FichaResponsavelEmpresa(props) {
  const { data, setData } = props;
  const [insert, setInsert] = React.useState(false)

  const handleChange = (id, field, value) => {
    setData((prevData) =>
      prevData.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  const handleAddRow = () => {
    setInsert(true)
    const newId = data.length > 0 ? Math.max(...data.map((row) => row.id)) + 1 : 1;
    setData([...data, { id: newId, nomeCompleto: "", cpf: "", rg: "", cargo: "", email: "" }]);
  };
  

  const handleRemoveRow = (id) => {
    setData(data.filter((row) => row.id !== id));
    setInsert(false)
  };

  return (
    <div style={{ width: '100%', marginTop: 20, padding: 10 }}>
      {data.map((row) => (
        <Paper key={row.id} style={{ padding: 20, marginBottom: 20, boxShadow: "0px 0px 15px rgba(185, 187, 211, 0.5)" }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                value={row.nomeCompleto}
                onChange={(e) => handleChange(row.id, "nomeCompleto", e.target.value)}
                label="Nome Completo"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextFieldCPF
                value={row.cpf}
                onChange={(e) => handleChange(row.id, "cpf", e.target.value)}
                label="CPF"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                value={row.rg}
                onChange={(e) => handleChange(row.id, "rg", e.target.value)}
                label="RG"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                value={row.cargo}
                onChange={(e) => handleChange(row.id, "cargo", e.target.value)}
                label="Cargo"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextFieldEmail
                value={row.email}
                onChange={(e) => handleChange(row.id, "email", e.target.value)}
                label="Email parar Assinatura Eletronica (www.autentique.com.br)"
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} container justifyContent="center" alignItems="center" style={{display: 'flex', justifyContent : 'center'}}>
                            <Button variant="contained" size='large' disabled={!insert} onClick={() =>{
                                Swal.fire({
                                      title : 'Confirmação de Registro', 
                                      text : 'Confirma a inclusão do registro?', 
                                      icon : 'question', 
                                      showCancelButton : true, 
                                      cancelButtonText : 'Não', 
                                      showConfirmButton : true, 
                                      confirmButtonText : 'Sim',
                                  }).then(resposta=>{      
                                      if(resposta.isConfirmed){      
                                        setInsert(false)                              
                                      }      
                                  })
                            } } color="primary">
                                <Save /><span style={{paddingLeft : '5px'}}>Gravar</span>
                            </Button>
                            <Button style={{marginLeft : '5px'}} variant="contained" size='large' color='secondary' onClick={() =>{
                                Swal.fire({
                                      title : 'Exclusão de Registro', 
                                      text : 'Confirma a exclusão do registro?', 
                                      icon : 'question', 
                                      showCancelButton : true, 
                                      cancelButtonText : 'Não', 
                                      showConfirmButton : true, 
                                      confirmButtonText : 'Sim',
                                      
                                  }).then(resposta=>{      
                                      if(resposta.isConfirmed){      
                                          handleRemoveRow(row.id)                              
                                      }      
                                  })
                            } }>
                                <Delete /> <span style={{paddingLeft : '5px'}}>Excluir</span>
                            </Button>
                        </Grid>
          </Grid>
        </Paper>
      ))}
      <Box display="flex" justifyContent="center" padding={2}>
        {!insert ? <Button
        variant="contained"
          onClick={handleAddRow}
          variant="contained"
          color="primary"
          startIcon={<Add />}
        >
          NOVO REPRESENTANTE
        </Button> : null }
      </Box>
    </div>
  );
}
